import { render, staticRenderFns } from "./BookingMenuWithBudgetHeader.vue?vue&type=template&id=6644e7ba&scoped=true&"
import script from "./BookingMenuWithBudgetHeader.vue?vue&type=script&lang=js&"
export * from "./BookingMenuWithBudgetHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6644e7ba",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6644e7ba')) {
      api.createRecord('6644e7ba', component.options)
    } else {
      api.reload('6644e7ba', component.options)
    }
    module.hot.accept("./BookingMenuWithBudgetHeader.vue?vue&type=template&id=6644e7ba&scoped=true&", function () {
      api.rerender('6644e7ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Booking/BookingMenuWithBudgetHeader.vue"
export default component.exports